import React from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { cn } from "./cn";

/** Bun section label; caption uses quiet sentence-case text between groups. */
export default function SectionLabel({ as: Tag = "h2", variant = "default", className, children, onClick, expanded, count, controls }) {
  if (onClick) {
    const Chevron = expanded ? ChevronDownIcon : ChevronRightIcon;
    return <button type="button" onClick={onClick} aria-expanded={expanded} aria-controls={controls}
      className={cn("flex min-h-11 w-full items-center gap-2 text-left font-instrument text-bun-label font-semibold uppercase tracking-wide text-bun-stone hover:text-bun-text focus-visible:outline focus-visible:outline-bun-blue sm:min-h-[26px]", className)}>
      <Chevron className="order-last ml-auto h-3 w-3 sm:order-first sm:ml-0" aria-hidden="true" />
      <span>{children}</span>{count != null && <span className="font-book normal-case tracking-normal">({count})</span>}
    </button>;
  }
  return (
    <Tag
      className={cn(
        "m-0 font-instrument text-bun-stone",
        variant === "caption"
          ? "text-bun-meta font-book normal-case leading-normal tracking-normal"
          : "text-bun-label font-semibold uppercase",
        className
      )}
    >
      {children}
    </Tag>
  );
}
